module.exports = __webpack_public_path__ + "static/media/icons8-docker.46dcb463.svg";